module.exports = __webpack_public_path__ + "img/appD32.1459252f.svg";